import t from "react";
import e from "./index168.mjs";
import c from "classnames";
const _ = ({
  label: l,
  onClick: o,
  disabled: n = !1,
  type: m = "button",
  isLoading: s,
  classes: u,
  dataTestId: r,
  id: b,
  Icon: a,
  hideLabelOnMobile: i
}) => /* @__PURE__ */ t.createElement(
  "button",
  {
    type: m === "button" ? "button" : "submit",
    className: c(u, e.button, {
      [e.hide_label_on_mobile]: i
    }),
    "data-testid": r || "button",
    disabled: n,
    onClick: o,
    id: b || "button"
  },
  s ? "Loading..." : /* @__PURE__ */ t.createElement("span", { className: e.label }, l),
  a ? /* @__PURE__ */ t.createElement(a, null) : null
);
export {
  _ as Button
};
